import ui from './ui';
import user from './user';

export default [
    ...ui,
    ...user
]